<template>
  <div class="profit-container">
    <div class="profit-search">
      <div class="search-item">
        <span>开始日期</span>
        <div>
          <el-date-picker
            v-model="search.timeStart"
            value-format="yyyyMMdd"
            type="date"
            placeholder="选择日期"
            :editable="false"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="search-item">
        <span>结束日期</span>
        <div>
          <el-date-picker
            v-model="search.timeEnd"
            value-format="yyyyMMdd"
            type="date"
            placeholder="选择日期"
            :editable="false"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="search-item">
        <div>
          <el-button
            :loading="search.loading"
            @click.native="searchSubmit()"
            type="primary"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <div class="profit-content">
      <div class="profit-c-title">
        <span> 退款情况 </span>
      </div>
      <div class="profit-c-line"></div>
      <div class="profit-c-swap">
        <div class="profit-c-block">
          <span class="profit-c-name">退款金额（元）</span>
          <span class="profit-c-info">{{
            contentData.refundAmount.toFixed(2)
          }}</span>
        </div>
        <div class="profit-c-block">
          <span class="profit-c-name">退款单数</span>
          <span class="profit-c-info">{{ contentData.refundCount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'
export default {
  data() {
    return {
      search: {
        timeStart: this.timeStartStr(),
        timeEnd: this.timeEndtStr(),
        loading: false
      },
      contentData: {
        refundAmount: 0,
        refundCount: 0
      }
    }
  },
  created() {},
  computed: {},
  methods: {
    timeStartStr() {
      var nowDate = new Date(new Date() - 30 * 24 * 60 * 60 * 1000)
      return `${nowDate.getFullYear()}${(nowDate.getMonth() + 1)
        .toString()
        .padStart(2, 0)}${nowDate.getDate()}`
    },
    timeEndtStr() {
      var nowDate = new Date()
      return `${nowDate.getFullYear()}${(nowDate.getMonth() + 1)
        .toString()
        .padStart(2, 0)}${nowDate.getDate()}`
    },
    searchSubmit() {
      this.search.loading = true
      axios({
        url: `${Urls.DOMAIN_YKT}/Order/Order/AuthorIncome`,
        method: 'POST',
        data: {
          startDateTime: this.search.timeStart,
          endDateTime: this.search.timeEnd,
          type: 0
        }
      })
        .then(data => {
          if (data.result.code === 0) {
            // 设置结果
            this.contentData.refundAmount = data.detail.refundTotal
            this.contentData.refundCount = data.detail.refundOrderNum
          } else {
            console.log('detail', data.result)
            this.$notify.error({
              position: 'bottom-right',
              title: '错误',
              message: '数据请求发生异常，请稍后再试。'
            })
          }
          this.search.loading = false
        })
        .catch(data => {
          this.search.loading = false
          console.log('error:', data)
          this.$notify.error({
            position: 'bottom-right',
            title: '错误',
            message: '数据请求发生异常，请稍后再试。'
          })
        })
    }
  },
  mounted() {
    this.searchSubmit()
  }
}
</script>

<style>
.profit-container .profit-search .search-item .el-textarea__inner,
body .el-input__inner {
  background-color: #fff;
}
.profit-container .profit-search .search-item .el-date-editor.el-input {
  width: 200px;
}
</style>

<style lang="scss" scoped>
.profit-container {
  display: flex;
  flex-direction: column;
  .profit-search {
    display: flex;
    justify-content: space-between;
    align-content: center;
    .search-item {
      display: flex;
      align-content: center;
      span {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 44px;
        letter-spacing: 1px;
        color: #262626;
        margin-right: 10px;
      }
    }
  }
  .profit-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 766px;
    height: 246px;
    border-radius: 5px;
    border: solid 1px #ebebeb;
    margin: 30px auto;
    .profit-c-title {
      display: flex;
      justify-content: center;
      height: 60px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      letter-spacing: 1px;
      color: #262626;
      span {
        line-height: 60px;
      }
    }
    .profit-c-line {
      width: 666px;
      height: 1px;
      background-color: #ebebeb;
    }
    .profit-c-swap {
      width: 666px;
      display: flex;
      justify-content: center;
      align-content: center;
      .profit-c-block {
        width: 308px;
        height: 120px;
        background-color: #fafafa;
        border-radius: 5px;
        margin: 25px;
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        text-align: center;
        font-family: MicrosoftYaHei;
        font-stretch: normal;
        letter-spacing: 0px;
        line-height: 30px;
        .profit-c-name {
          font-size: 14px;
          font-weight: normal;
          color: #858585;
        }
        .profit-c-info {
          font-size: 20px;
          font-weight: bold;
          color: #262626;
        }
      }
    }
  }
}
</style>
